import React from "react";

import { Field, Hint, Label } from "./styles";

interface LabeledFieldProps {
    label?: React.ReactNode;
    hint?: React.ReactNode;
    // danger — подсказка становится сообщением об ошибке валидации.
    hintTone?: "default" | "danger";
    htmlFor?: string;
    className?: string;
    children: React.ReactNode;
}

export const LabeledField = ({
    label,
    hint,
    hintTone = "default",
    htmlFor,
    className,
    children,
}: LabeledFieldProps) => (
    <Field className={className}>
        {label && <Label htmlFor={htmlFor}>{label}</Label>}
        {children}
        {hint && <Hint $tone={hintTone}>{hint}</Hint>}
    </Field>
);
